import { render, staticRenderFns } from "./SummaryAppraisal.vue?vue&type=template&id=4d0c2b4a&scoped=true&"
import script from "./SummaryAppraisal.vue?vue&type=script&lang=js&"
export * from "./SummaryAppraisal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0c2b4a",
  null
  
)

export default component.exports